import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

const ScreenReader = ({children, type}) => {
    const {t} = useTranslation();

    return (
        <span className="sr-only">
            {children ? children : t(`screenReader.${type}`)}
        </span>
    );
};

ScreenReader.propTypes = {
    children: PropTypes.string,
    type: PropTypes.oneOf(['dialog', 'newWindow']),
};

export default ScreenReader;
